import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";

/**
 * HelpHint — small "?" icon that reveals a contextual explanation.
 * Usage: <HelpHint title="Stream URL" text="This is the internet address…"
 *                  learnMoreSlug="connect-your-stream" />
 */
export const HelpHint = ({ title, text, learnMoreSlug, testid = "help-hint" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <span className="relative inline-flex align-middle" ref={ref}>
      <button type="button" onClick={() => setOpen(!open)} data-testid={testid}
        className="text-ink-muted hover:text-brand-amber transition ml-1.5" aria-label={`Help: ${title}`}>
        <HelpCircle className="h-3.5 w-3.5" />
      </button>
      {open && (
        <span className="absolute left-0 top-6 z-50 w-64 rounded-lg border border-line bg-bg-surface p-3 shadow-xl text-left"
          data-testid={`${testid}-popover`}>
          <span className="block text-xs font-bold text-ink-primary">{title}</span>
          <span className="block text-[11px] text-ink-secondary mt-1 leading-relaxed normal-case tracking-normal font-sans">{text}</span>
          {learnMoreSlug && (
            <Link to={`/dashboard/help/getting-started#${learnMoreSlug}`} data-testid={`${testid}-learn-more`}
              className="mt-2 inline-block text-[11px] font-bold text-brand-amber hover:underline">Learn More →</Link>
          )}
        </span>
      )}
    </span>
  );
};

export default HelpHint;
